import flatpickr from "flatpickr"
import * as util from "./util"

/* To locally debug this script via Webflow the best option I've found is to
add two scripts in Webflow:
<script src="http://localhost:3000/????.bundle.js"></script>
<script src="angry-boyd-1669aa.netlify.app/????.bundle.js" crossorigin="anonymous"></script>
The below check ensures that if localhost loads successfully the second
(production) script won't run.
Initially I tried to add the script dynamically in Webflow but that didn't
work - I needed it to run immediately but it wouldn't. */
if (typeof SharesyWebflow === "undefined") {
  util.initSentry()

  window.amplitudeOnLoad = function (instance) {
    util.amplitudeInit(instance, "Landing Page Viewed")
  }

  // Wrap everything with Revealing Module Pattern
  window.SharesyWebflow = (function () {
    var searchParams = util.getSearchParams()

    var fp // flatpickr
    var date
    var startTime
    var endTime

    // Time filter status
    var TIME_NONE = 0
    var TIME_START = 1
    var timeStatus = TIME_NONE

    function logAmplitudeEvent(eventName, eventProps) {
      let eventProperties = {}
      if (eventProps) {
        eventProperties = eventProps
      }
      try {
        eventProperties["Selected Date"] = document.querySelector(
          ".text-date-input-space"
        ).value
        eventProperties["Start Time"] = startTime
        eventProperties["End Time"] = endTime
        eventProperties["Type"] =
          document.getElementById("input-text-type").innerText
      } catch (e) {}
      util.logAmplitudeEvent(eventName, eventProperties)
    }

    // Fired each time a date is selected in the date picker
    function flatpickrDateChange(selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        dateTextShort = selectedDates[0].toLocaleDateString("en-GB", {
          month: "short",
          day: "numeric",
        })
        // Need to remove timezone offset before splitting ISO string
        // See: https://stackoverflow.com/a/50130338
        let d = new Date(
          selectedDates[0].getTime() -
            selectedDates[0].getTimezoneOffset() * 60000
        )
        date = d.toISOString().split("T")[0]

        setDateText()
        try {
          setFromPrice(
            spacesJson[0].dates.filter((d) => d.start_date === date)[0]
              .min_price_per_hour_day,
            true
          )
        } catch (err) {}
        try {
          logAmplitudeEvent("Select Date (Landing)")
        } catch (err) {
          util.logToSentry(err)
        }
      }
    }

    function updateUrlParam(paramName, paramValue) {
      // Update current URL
      let url = new URL(window.location.href)
      url.searchParams.set(paramName, paramValue)
      window.history.replaceState(null, null, url)

      // Update URL of main button
      let searchButton = document.getElementById("booking-section-button")
      url = new URL(searchButton.href)
      /*let params = new URLSearchParams(url.search);
      params.set(paramName, paramValue);
      url.search = params;*/
      url.searchParams.set(paramName, paramValue)
      searchButton.href = url.href
    }

    function deleteUrlParam(paramName) {
      // Update current URL
      let url = new URL(window.location.href)
      url.searchParams.delete(paramName)
      window.history.replaceState(null, null, url)

      // Update URL of main button
      let searchButton = document.getElementById("booking-section-button")
      url = new URL(searchButton.href)
      url.searchParams.delete(paramName)
      searchButton.href = url.href
    }

    function setDateText() {
      let inputTextDate = document.getElementById("input-text-date")
      inputTextDate.innerText = new Date(date).toLocaleDateString("en-GB", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      })
      inputTextDate.classList.add("completed")
      updateUrlParam("date", date)
    }

    function setTimeAvailability() {
      // Diable all times by default
      const timeButtons = document.getElementsByClassName("time-button")
      for (const tb of timeButtons) {
        tb.addEventListener("click", timeButtonClick)
      }
    }

    function timeButtonClick(e) {
      let selectedButtons = document.getElementsByClassName(
        "time-button selected"
      )
      if (timeStatus === TIME_NONE) {
        timeStatus = TIME_START
        e.currentTarget.classList.add("selected")
        startTime = selectedButtons[0].innerText

        document.getElementById("time-modal-header").innerText =
          "Choose an end time"
        document.getElementById("time-modal-clear").style.display = "block"

        document
          .getElementById("start-time-select")
          .classList.remove("highlighted")
        document.getElementById("end-time-select").classList.add("highlighted")
        let inputTextStartTime = document.getElementById(
          "input-text-start-time"
        )
        inputTextStartTime.innerText = startTime
        inputTextStartTime.classList.add("completed")
        // In case an end time was already selected
        let inputTextEndTime = document.getElementById("input-text-end-time")
        inputTextEndTime.innerText = "Choose time"
        inputTextEndTime.classList.remove("completed")

        const timeButtons = document.getElementsByClassName("time-button")
        for (const tb of timeButtons) {
          if (tb.innerText < startTime) {
            tb.classList.add("disabled")
          } else if (tb.innerText > startTime) {
            tb.addEventListener("mouseover", mouseoverSelectOtherTimes)
            tb.addEventListener("mouseout", mouseoutSelectOtherTimes)
          }
        }

        document.querySelector(".time-modal").style.display = "none"
        setTimeout(function () {
          document.querySelector(".time-modal").style.display = "flex"
        }, 300)

        try {
          logAmplitudeEvent("Select Start Time (Landing)")
        } catch (err) {}

        updateUrlParam("starttime", startTime.replace(":", ""))
      } else if (timeStatus === TIME_START) {
        if (e.currentTarget.innerText > startTime) {
          endTime = e.currentTarget.innerText

          let inputTextEndTime = document.getElementById("input-text-end-time")
          inputTextEndTime.innerText = endTime
          inputTextEndTime.classList.add("completed")

          document.querySelector(".time-modal").style.display = "none"
          try {
            document
              .getElementById("start-time-select")
              .classList.remove("highlighted")
          } catch (err) {}
          try {
            document
              .getElementById("end-time-select")
              .classList.remove("highlighted")
          } catch (err) {}

          try {
            logAmplitudeEvent("Select End Time (Landing)")
          } catch (err) {}
          updateUrlParam("endtime", endTime.replace(":", ""))
          updateDuration()
        }
      }
    }

    function timeClear(retainTimes) {
      const timeButtons = document.getElementsByClassName("time-button")
      for (const tb of timeButtons) {
        tb.classList.remove("selected")
        tb.classList.remove("auto-selected")
        tb.classList.remove("disabled")
        tb.removeEventListener("mouseover", mouseoverSelectOtherTimes)
        tb.removeEventListener("mouseout", mouseoutSelectOtherTimes)
      }
      document.getElementById("time-modal-header").innerText =
        "Choose a start time"
      document.getElementById("time-modal-clear").style.display = "none"

      timeStatus = TIME_NONE

      if (!(retainTimes === true)) {
        startTime = undefined
        endTime = undefined

        let inputTextStartTime = document.getElementById(
          "input-text-start-time"
        )
        inputTextStartTime.innerText = "Choose time"
        inputTextStartTime.classList.remove("completed")
        let inputTextEndTime = document.getElementById("input-text-end-time")
        inputTextEndTime.innerText = "Choose time"
        inputTextEndTime.classList.remove("completed")
        try {
          document
            .getElementById("start-time-select")
            .classList.remove("highlighted")
        } catch (err) {}
        try {
          document
            .getElementById("end-time-select")
            .classList.remove("highlighted")
        } catch (err) {}
      }
    }

    function timeClose() {
      if (timeStatus === TIME_NONE) {
        try {
          document
            .getElementById("start-time-select")
            .classList.remove("highlighted")
        } catch (err) {}
      } else if (timeStatus === TIME_START) {
        timeClear()
      }
      document.querySelector(".time-modal").style.display = "none"

      try {
        logAmplitudeEvent("Close Time Modal (Landing)")
      } catch (err) {}
    }

    // If just a start time is selected, as the user mouses over potential end times, colour all the times in between.
    function mouseoverSelectOtherTimes(e) {
      if (timeStatus === TIME_START) {
        let mouseoverTime = e.currentTarget.innerText
        const timeButtons = document.getElementsByClassName("time-button")
        for (const tb of timeButtons) {
          if (tb.innerText < mouseoverTime && tb.innerText > startTime) {
            tb.classList.add("auto-selected")
          }
        }
      }
    }

    function mouseoutSelectOtherTimes(e) {
      if (timeStatus === TIME_START) {
        let mouseoverTime = e.currentTarget.innerText
        const timeButtons = document.getElementsByClassName("time-button")
        for (const tb of timeButtons) {
          if (tb.innerText < mouseoverTime && tb.innerText > startTime) {
            tb.classList.remove("auto-selected")
          }
        }
      }
    }

    function updateDuration() {
      // Update field text
      let numHours =
        parseInt(endTime.substring(0, 2)) - parseInt(startTime.substring(0, 2))
      let numMins =
        parseInt(endTime.substring(3, 5)) - parseInt(startTime.substring(3, 5))
      if (numMins < 0) {
        numMins = Math.abs(numMins)
        numHours--
      }
      let numHoursFixed = numHours
      if (numMins > 0) {
        numHoursFixed = (numHours + numMins / 60).toFixed(1)
      }
      let hoursText = " (" + numHoursFixed
      if (numHours > 1 || numMins != 0) {
        hoursText += " hours)"
      } else {
        hoursText += " hour)"
      }
      let inputTextStartTime = document.getElementById("input-text-start-time")
      inputTextStartTime.innerText = startTime
      inputTextStartTime.classList.add("completed")
      let inputTextEndTime = document.getElementById("input-text-end-time")
      inputTextEndTime.innerText = endTime + hoursText
      inputTextEndTime.classList.add("completed")
    }

    function displayTimeModal() {
      timeClear(true)
      setTimeAvailability()

      document.querySelector(".time-modal").style.display = "flex"
      document.getElementById("start-time-select").classList.add("highlighted")
      document.getElementById("end-time-select").classList.remove("highlighted")
    }

    function selectType(typeId, typeName) {
      if (typeId === "all-types") {
        deleteUrlParam("types")
      } else {
        updateUrlParam("types", typeId)
      }
      document.getElementById("input-text-type").innerText = typeName
      document.getElementById("modal-container-clear").style.display = "none"
      document.getElementById("type-modal").style.display = "none"
      document.getElementById("type-select").classList.remove("highlighted")
      logAmplitudeEvent("Select Type (Landing)")
    }

    function init() {
      try {
        let searchButton = document.getElementById("booking-section-button")
        searchButton.addEventListener("click", function (e) {
          logAmplitudeEvent("Press Search (Landing)")
        })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        let monthsFromNow = new Date()
        monthsFromNow.setDate(monthsFromNow.getDate() + 365)
        let fourDaysFromNow = new Date()
        fourDaysFromNow.setDate(fourDaysFromNow.getDate() + 4)

        fp = flatpickr(".flatpickr", {
          enableTime: false,
          wrap: true,
          minDate: fourDaysFromNow,
          maxDate: monthsFromNow,
          disableMobile: "true",
          monthSelectorType: "static",
          locale: {
            firstDayOfWeek: 1, // start week on Monday
          },
          onChange: function (selectedDates, dateStr, instance) {
            flatpickrDateChange(selectedDates, dateStr, instance)
          },
        })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("start-time-select")
          .addEventListener("click", function (e) {
            displayTimeModal()
            logAmplitudeEvent("Open Start Time (Landing)")
          })
        document
          .getElementById("end-time-select")
          .addEventListener("click", function (e) {
            if (
              !document
                .getElementById("end-time-select")
                .classList.contains("highlighted")
            ) {
              displayTimeModal()
            }
            logAmplitudeEvent("Open End Time (Landing)")
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("type-select")
          .addEventListener("click", function (e) {
            if (
              !document
                .getElementById("type-select")
                .classList.contains("highlighted")
            ) {
              document
                .getElementById("type-select")
                .classList.add("highlighted")
            }
            document.getElementById("modal-container-clear").style.display =
              "block"
            document.getElementById("type-modal").style.display = "block"
            logAmplitudeEvent("Open Type (Landing)")
          })

        const typeButtons = document.getElementsByClassName("sort-button")
        for (const tb of typeButtons) {
          let typeId = tb.id
          if (typeId !== "all-types") {
            urlSplit = tb.href.split("/")
            typeId = urlSplit[urlSplit.length - 1]
          }
          tb.addEventListener("click", function (e) {
            selectType(typeId, tb.innerText)
            e.preventDefault()
          })
        }
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("date-select")
          .addEventListener("click", function (e) {
            logAmplitudeEvent("Open Choose Date (Landing)")
          })

        // Add listeners to the time modal buttons.
        elem = document.getElementById("time-modal-clear")
        elem.addEventListener("click", function () {
          timeClear()
          try {
            logAmplitudeEvent("Clear Times (Landing)")
          } catch (err) {}
        })
        elem = document.getElementById("time-modal-close")
        elem.addEventListener("click", timeClose)
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        if (searchParams.has("types")) {
          typeId = searchParams.get("types")
          const typeButtons = document.getElementsByClassName("sort-button")
          for (const tb of typeButtons) {
            if (tb.href.includes(typeId)) {
              selectType(typeId, tb.innerText)
            }
          }
        }
      } catch (err) {
        util.logToSentry(err)
      }
      // Close type modal when click outside
      try {
        document
          .getElementById("modal-container-clear")
          .addEventListener("click", (e) => {
            if (e.target.id === "modal-container-clear") {
              document.getElementById("modal-container-clear").style.display =
                "none"
              document.getElementById("type-modal").style.display = "none"
              document
                .getElementById("type-select")
                .classList.remove("highlighted")
              logAmplitudeEvent("Close Type - Click Outside")
            }
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        if (searchParams.has("starttime") && searchParams.has("endtime")) {
          startTime =
            searchParams.get("starttime").substring(0, 2) +
            ":" +
            searchParams.get("starttime").substring(2, 4)
          endTime =
            searchParams.get("endtime").substring(0, 2) +
            ":" +
            searchParams.get("endtime").substring(2, 4)
        }

        if (searchParams.has("date")) {
          date = searchParams.get("date")
          fp.setDate(date)
          flatpickrDateChange(fp.selectedDates)
        }
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        let targetNode =
          document.getElementsByClassName("flatpickr-calendar")[0]
        let flatpickrObserver = new MutationObserver(function () {
          if (targetNode.classList.contains("open")) {
            document.getElementById("date-select").classList.add("highlighted")
          } else {
            document
              .getElementById("date-select")
              .classList.remove("highlighted")
          }
        })
        flatpickrObserver.observe(targetNode, {
          attributes: true,
          childList: true,
        })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document.getElementsByClassName("flatpickr-input")[0].addEventListener(
          "focus",
          function (e) {
            e.currentTarget.blur()
          },
          true
        )
        document.getElementById("date-select").addEventListener(
          "focus",
          function (e) {
            e.currentTarget.blur()
          },
          true
        )
      } catch (err) {
        util.logToSentry(err)
      }

      // Different Location event listeners
      try {
        document
          .getElementById("text-link-different-location")
          .addEventListener("click", (e) => {
            document.getElementById("modal-container").style.display = "flex"
            document.getElementById("different-location-modal").style.display =
              "flex"
            logAmplitudeEvent("Open Different Location Modal")
          })
      } catch (err) {
        util.logToSentry(err)
      }
      try {
        document
          .getElementById("different-location-modal-close")
          .addEventListener("click", (e) => {
            document.getElementById("modal-container").style.display = "none"
            document.getElementById("different-location-modal").style.display =
              "none"
            logAmplitudeEvent("Close Different Location Modal")
          })
      } catch (err) {
        util.logToSentry(err)
      }
      // Close all modals when click outside
      try {
        document
          .getElementById("modal-container")
          .addEventListener("click", (e) => {
            if (e.target.id === "modal-container") {
              document.getElementById("modal-container").style.display = "none"
              document.getElementById(
                "different-location-modal"
              ).style.display = "none"
              logAmplitudeEvent("Close Modals - Click Outside")
            }
          })
      } catch (err) {
        util.logToSentry(err)
      }

      // Amplitude Select Space events
      try {
        const spaceCards = document.getElementsByClassName("space-card")
        for (const sc of spaceCards) {
          sc.addEventListener("click", function (e) {
            // Use currentTarget rather than target to get the <a> tag
            const eventProperties = {
              Slug: new URL(e.currentTarget.href).pathname.split("/").pop(),
              Space: e.currentTarget
                .querySelector(".space-name")
                .innerText.replace("'", ""),
              Venue: e.currentTarget
                .querySelector(".venue-name")
                .innerText.replace("'", ""),
              "Venue + Space": e.currentTarget
                .querySelector(".name-hidden")
                .innerText.replace("'", ""),
              Capacity:
                e.currentTarget.querySelector(".capacity-hidden").innerText,
              Price: e.currentTarget.querySelector(
                ".price-hidden > .price-inner"
              ).innerText,
            }
            logAmplitudeEvent("Select Space (Landing)", eventProperties)
          })
        }
      } catch (err) {
        util.logToSentry(err)
      }
    }

    return {
      init: init,
    }
  })()
}
